module.exports = __webpack_public_path__ + "static/amusing-ourselves-to-death-8c19fb0491546220212d826d2330374a.jpg";